import { render, staticRenderFns } from "./dash-task.vue?vue&type=template&id=a9c93c5a&scoped=true"
import script from "./dash-task.vue?vue&type=script&lang=js"
export * from "./dash-task.vue?vue&type=script&lang=js"
import style0 from "./dash-task.vue?vue&type=style&index=0&id=a9c93c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c93c5a",
  null
  
)

export default component.exports